export class SettingsDirectDebitsEntity {
  constructor() {
    this.directDebitsName = null;
    this.directDebitsLastKnownDate = null;
    this.directDebitsFrequency = null;
    this.directDebitsLastKnownAmount = null;
  }
  getSettingsDirectDebitsEntity() {
    return this;
  }
}

export default SettingsDirectDebitsEntity;
